<template>
  <div class="d-flex justify-center align-center my-3">
    <v-btn text small color="primary" @click="changeMonth(prevMonth)">
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t("message.common.previous") }}
    </v-btn>
    <span class="mx-5 text-uppercase">{{ currentMonth.format("MMMM") }}</span>
    <v-btn
      text
      small
      color="primary"
      @click="changeMonth(nextMonth)"
      :disabled="actualDate === currentMonth.format('MMMM YY')"
    >
      {{ $t("message.common.next") }}
      <v-icon right>mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import moment from "moment";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "ChartPagination",
  props: {
    currentMonth: {
      type: Object,
      required: true
    },
    componentName: {
      type: String,
      default: ""
    }
  },
  computed: {
    nextMonth() {
      return moment(this.currentMonth).add(1, "month");
    },
    prevMonth() {
      return moment(this.currentMonth).subtract(1, "month");
    },
    actualDate() {
      return moment().format("MMMM YY");
    }
  },
  methods: {
    changeMonth(val) {
      const gtmEventParams = {
        event: GTM_EVENT_NAME.CHART_MONTH_CHANGE,
        old_month: moment(this.currentMonth).format("MM.YYYY"),
        new_month: moment(val).format("MM.YYYY")
      };
      if (this.componentName) gtmEventParams.component = this.componentName;

      this.$gtm.trackCustomEvent(gtmEventParams);

      this.$emit("changeMonth", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
